/**
 * Domains that label the admission number as "Student ID" (useStudentIdLabel,
 * e.g. montestory.org) still get backend messages worded "Admission number".
 * Reword them for display; other domains get the text unchanged.
 */
export function withStudentIdWording(text, useStudentIdLabel) {
  if (!useStudentIdLabel || text == null) return text;
  return String(text)
    .replace(/admission number\s*\/\s*student id/gi, "Student ID")
    .replace(/admission numbers/g, "student IDs")
    .replace(/Admission numbers/g, "Student IDs")
    .replace(/Admission Numbers/g, "Student IDs")
    .replace(/admission number/g, "student ID")
    .replace(/Admission number/g, "Student ID")
    .replace(/Admission Number/g, "Student ID");
}
